var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHouse2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bold_shop",
    "data-name": "vuesax/bold/shop",
    transform: "translate(-172 -252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shop",
    transform: "translate(172 252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.993,4.388l-.181-1.731C12.55.769,11.693,0,9.862,0H3.137C1.3,0,.45.769.181,2.675L.012,4.394A2.569,2.569,0,0,0,.525,6.219a2.506,2.506,0,0,0,2.019.969A2.558,2.558,0,0,0,4.562,6.162a2.384,2.384,0,0,0,3.9.025,2.562,2.562,0,0,0,2,1,2.489,2.489,0,0,0,2.05-1.019A2.545,2.545,0,0,0,12.993,4.388Z",
    transform: "translate(0.982 0.781)",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M1.394.022A1.559,1.559,0,0,0,0,1.578V3.291A.307.307,0,0,0,.306,3.6H3.288a.307.307,0,0,0,.306-.306V1.8C3.6.491,2.831-.128,1.394.022Z",
    transform: "translate(5.7 10.39)",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M11.713,1.137V3A3.126,3.126,0,0,1,8.588,6.125a.307.307,0,0,1-.306-.306V4.325a2.369,2.369,0,0,0-.719-1.85,2.425,2.425,0,0,0-1.694-.569,4.284,4.284,0,0,0-.481.025A2.178,2.178,0,0,0,3.431,4.106V5.819a.307.307,0,0,1-.306.306A3.126,3.126,0,0,1,0,3V1.15A.625.625,0,0,1,.837.562,2.919,2.919,0,0,0,1.35.688a1.453,1.453,0,0,0,.231.025,2.416,2.416,0,0,0,.3.019,3.176,3.176,0,0,0,2-.731A3.032,3.032,0,0,0,5.856.731,2.993,2.993,0,0,0,7.825.013,3.157,3.157,0,0,0,9.8.731a2.861,2.861,0,0,0,.331-.019c.075-.006.144-.012.213-.025A3.011,3.011,0,0,0,10.887.55.623.623,0,0,1,11.713,1.137Z",
    transform: "translate(1.644 7.862)",
    fill: "#292d32",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0H15V15H0Z",
    transform: "translate(15 15) rotate(180)",
    fill: "none",
    opacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse2);
export default __webpack_public_path__ + "static/media/house2.553eae06590192fbee61a8a50a8b2fd2.svg";
export { ForwardRef as ReactComponent };